import { gql } from "@apollo/client";

export const SET_MANUAL_REVIEW_REQUIRED = gql`
  mutation setManualReviewRequired($input: SetManualReviewRequiredInput!) {
    invoice {
      setManualReviewRequired(input: $input) {
        success
      }
    }
  }
`;
